import { memo } from 'react'
import { VisibilityHandler } from './components/visibility-handler'
import { ChatList } from '$comp/_app/components/leftPanel/components/chat-list'

export const RoomList = memo(({ zIndex = 1 }: { zIndex?: number }) => {
  return (
    <VisibilityHandler
      zIndex={zIndex}
      style={{ height: 'calc(var(--vh-detect-notch, 1vh) * 100)' }}
    >
      <ChatList />
    </VisibilityHandler>
  )
})
